module.exports = __webpack_public_path__ + "static/media/image.7069ac69.svg";